import React from 'react';
import PropTypes from 'prop-types';
import GDTableAssignmentSummary from '../GDTable/GDTableAssignmentSummary/GDTableAssignmentSummary';
import './ImageSearchResultAssignmentSummary.scss';

const ImageSearchResultAssignmentSummary = (props) => {
  return (
    <div className="image-search-result-assignment-summary">
      <div className="summary-assignment-title">Assignment Summary</div>
        <GDTableAssignmentSummary
          type={props.type}
          summaryPanel={props.summaryPanel}
          selectedPages={props.selectedPages}
          summaryContent={props.searchContent}
          summaryData={props.summaryData}
          attachAndArchive={props.attachAndArchive}
          isAssignPages={props.isAssignPages}
          updatedSummaryData={props.updatedSummaryData}
          documentTypes={props.documentTypes}
        />
    </div>
  );
};


ImageSearchResultAssignmentSummary.propTypes = {
  summaryPanel: PropTypes.array,
  searchContent: PropTypes.array,
  selectedPages: PropTypes.array
};

ImageSearchResultAssignmentSummary.defaultProps = {
  summaryPanel: {},
  searchContent: [],
  selectedPages: 0,
};

export default ImageSearchResultAssignmentSummary;
